import { QueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';

// Helper pour invalider tout ce qui dépend d'un chantier
export function invalidateChantier(qc: QueryClient, entrepriseId: string, chantierId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.detail(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.metrics(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.frais(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.facturesClients(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.facturesFournisseurs(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.paiements(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.devis(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.contratsST(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.finances.ajustements(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.affectations.chantier(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.analyseIA.chantier(entrepriseId, chantierId) });
  // Aussi invalider la liste globale
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.all(entrepriseId) });
  // Charts du chantier
  qc.invalidateQueries({ queryKey: queryKeys.charts.chantier(entrepriseId, chantierId) });
  // Date de fin effective
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.dateFin(entrepriseId, chantierId) });
  // Et la trésorerie (les modifications de chantier impactent les flux)
  qc.invalidateQueries({ queryKey: ['tresorerie', entrepriseId] });
}

// Helper pour invalider tout ce qui dépend de l'équipe
export function invalidateEquipe(qc: QueryClient, entrepriseId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.equipe.all(entrepriseId) });
  qc.invalidateQueries({ queryKey: queryKeys.equipe.stats(entrepriseId) });
  // Les changements d'équipe impactent le planning
  qc.invalidateQueries({ queryKey: queryKeys.affectations.calendarAll(entrepriseId) });
}

// Helper pour invalider les affectations du calendrier
export function invalidateAffectationsCalendrier(qc: QueryClient, entrepriseId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.affectations.calendarAll(entrepriseId) });
  // Aussi invalider les vues par mois si elles existent
  qc.invalidateQueries({ queryKey: ['affectations', entrepriseId, 'calendrier'] });
}

// Helper pour invalider les finances d'un chantier
export function invalidateFinancesChantier(qc: QueryClient, entrepriseId: string, chantierId: string) {
  qc.invalidateQueries({ queryKey: ['finances', entrepriseId, chantierId] });
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.metrics(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: ['tresorerie', entrepriseId] });
  qc.invalidateQueries({ queryKey: queryKeys.charts.chantier(entrepriseId, chantierId) });
}

// Helper pour invalider la trésorerie
export function invalidateTresorerie(qc: QueryClient, entrepriseId: string) {
  qc.invalidateQueries({ queryKey: ['tresorerie', entrepriseId] });
}

// Helper pour invalider la date de fin effective d'un chantier
export function invalidateChantierDateFin(qc: QueryClient, entrepriseId: string, chantierId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.chantiers.dateFin(entrepriseId, chantierId) });
}

// Helper pour invalider les sous-traitants
export function invalidateSousTraitants(qc: QueryClient, entrepriseId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.sousTraitants.all(entrepriseId) });
}

// Helper pour invalider les alertes
export function invalidateAlertes(qc: QueryClient, entrepriseId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.alertes.all(entrepriseId) });
}

// Helper pour invalider les notifications
export function invalidateNotifications(qc: QueryClient, userId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.notifications.all(userId) });
}

// Helper pour invalider l'analyse IA d'un chantier
export function invalidateAnalyseIA(qc: QueryClient, entrepriseId: string, chantierId: string) {
  qc.invalidateQueries({ queryKey: queryKeys.analyseIA.chantier(entrepriseId, chantierId) });
  qc.invalidateQueries({ queryKey: queryKeys.alertes.all(entrepriseId) });
}
